
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import BasicBars from '../../examples/visx/BasicBars';
import srcBasicBars from '../../examples/visx/BasicBars?raw';
import BasicGlyphs from '../../examples/visx/BasicGlyphs';
import srcBasicGlyphs from '../../examples/visx/BasicGlyphs?raw';
import Temperatures from '../../examples/visx/Temperatures';
import srcTemperatures from '../../examples/visx/Temperatures?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "visx.mdx",
    route: "/components/visx",
    meta: {},
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"visx"}</h1><p>{"Theme support and helper components to build "}<inlineCode parentName="p">{"visx/xychart"}</inlineCode>{" charts that adhere to Material design styleguide."}</p><h2>{"Bars"}</h2><p>{"Recreates a bar chart example from Material Design docs. It showcases how the theme can be set up."}</p>{"\n"}<CodeExample src={srcBasicBars} mdxType="CodeExample"><BasicBars parentName="CodeExample" mdxType="BasicBars" /></CodeExample><h2>{"Glyphs"}</h2><p>{"Recreates a chart example from Material Design docs with custom glyphs."}</p>{"\n"}<CodeExample src={srcBasicGlyphs} mdxType="CodeExample"><BasicGlyphs parentName="CodeExample" mdxType="BasicGlyphs" /></CodeExample><h2>{"Lines"}</h2><p>{"Recreates a temperature chart example from Material Design docs. It showcases how to set up a Material Design styled tooltip."}</p>{"\n"}<CodeExample src={srcTemperatures} mdxType="CodeExample"><Temperatures parentName="CodeExample" mdxType="Temperatures" /></CodeExample></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
